/**
 * Severity Action Options
 *
 * Configuration for severity change action menu items.
 * Extracted from index.tsx row actions to centralize severity change definitions.
 */

import {
  Bars2Icon,
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import { RiskSeverity, SeverityDef } from '@/types';

/**
 * Get severity change menu options for a vulnerability
 * Returns menu items with icons and severity values
 */
interface SeverityOption {
  label: string;
  type?: 'label';
  icon?: React.JSX.Element;
  value?: string;
}

export function getSeverityChangeOptions(): SeverityOption[] {
  return [
    {
      label: 'Change Severity',
      type: 'label',
    },
    {
      label: SeverityDef[RiskSeverity.Critical],
      icon: <ChevronDoubleUpIcon className="size-5" />,
      value: RiskSeverity.Critical,
    },
    {
      label: SeverityDef[RiskSeverity.High],
      icon: <ChevronUpIcon className="size-5" />,
      value: RiskSeverity.High,
    },
    {
      label: SeverityDef[RiskSeverity.Medium],
      icon: <Bars2Icon className="size-5" />,
      value: RiskSeverity.Medium,
    },
    {
      label: SeverityDef[RiskSeverity.Low],
      icon: <ChevronDownIcon className="size-5" />,
      value: RiskSeverity.Low,
    },
    {
      label: SeverityDef[RiskSeverity.Info],
      icon: <ChevronDoubleDownIcon className="size-5" />,
      value: RiskSeverity.Info,
    },
  ];
}
